import { useTranslation } from "react-i18next";

export default function LanguageSwitcher() {
    const { i18n } = useTranslation();

    return (
        <div style={{ display: "flex", gap: "4px" }}>
            {["en", "ru", "tk"].map((lang) => (
                <button
                    key={lang}
                    onClick={() => {
                        i18n.changeLanguage(lang);
                        localStorage.setItem("appLanguage", lang);
                    }}
                    style={{
                        padding: "4px 8px",
                        borderRadius: "4px",
                        border: i18n.language === lang ? "2px solid #6D40C8" : "1px solid #9474D5",
                        background: "transparent",
                        cursor: "pointer",
                        fontSize: "13px",


                    }}
                >
                    {lang.toUpperCase()}
                </button>
            ))}
        </div>
    );
}